import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import Hidden from "@insite/mobius/Hidden";
import Typography from "@insite/mobius/Typography";
import styles from "@store/Components/Store/StoreSchematicsView/styles";
import GridItem from "@store/MobiusOverrides/GridItem/GridItem";
import ProductContextAvailability from "@store/Overrides/Components/ProductContextAvailability";
import ProductPrice from "@store/Overrides/Components/ProductPrice";
import { getShowNormalPrice, getShowRetailPrice } from "@store/Store/Context/ContextSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import React from "react";
import { connect } from "react-redux";

type Props = HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: StoreApplicationState) => {
    return {
        isSignedIn: state.context.session.userName && !getCurrentUserIsGuest(state),
        rememberMe: state.context.session.rememberMe,
        showNormalPrice: getShowNormalPrice(state),
        showRetailPrice: getShowRetailPrice(state),
    };
};


const StorePartsActions: React.FC<Props> = ({
    productContext,
    isSignedIn,
    rememberMe,
    showNormalPrice,
    showRetailPrice,
}) => {

    return (
        <>
            <GridItem {...styles.availabilityBodyGridCell}>
                {((isSignedIn || rememberMe) && productContext) && (
                    <ProductContextAvailability
                        isCondensed={false}
                        qtyOrdered={productContext.productInfo.qtyOrdered}
                        extendedStyles={styles.availabilityStyles} />
                )}
            </GridItem>
            <GridItem {...styles.normalPriceBodyGridCell}>
                {((isSignedIn || rememberMe) && showNormalPrice && productContext) && (
                    <>
                        <Hidden above="md">
                            <ProductContextAvailability
                                isCondensed={false}
                                extendedStyles={styles.availabilityStyles} />
                        </Hidden>
                        <ProductPrice
                            showLabel={false}
                            showNormalOnly={true}
                        />
                    </>
                )}
            </GridItem>
            <GridItem {...styles.retailPriceBodyGridCell}>
                {((isSignedIn || rememberMe) && showRetailPrice) && (
                    <>
                        <Hidden above="md">
                            {productContext && (
                                <ProductPrice
                                    showRetailOnly={true}
                                    showRetailLabel={true}
                                />
                            )}
                        </Hidden>
                        <Hidden below="lg">
                            {productContext && (
                                <ProductPrice
                                    showRetailOnly={true}
                                    showRetailLabel={false}
                                />
                            )}
                        </Hidden>
                    </>
                )}
            </GridItem>
            {productContext ? (
                <>
                    <GridItem {...styles.addProductBodyGridCell}>
                        <ProductQuantityOrdered labelOverride="" />
                        <ProductAddToCartButton
                            labelOverride=""
                            extendedStyles={styles.addToCartButton}
                        />
                    </GridItem>
                    <GridItem {...styles.mobileAddProductBodyGridCell}>
                        <ProductQuantityOrdered labelOverride="" />
                        <ProductAddToCartButton extendedStyles={styles.mobileAddToCartButton}/>
                    </GridItem>
                </>
            ) : (
                <GridItem {...styles.callBranchBodyGridCell}>
                    <Typography>
                        {translate("Call Branch*")}
                    </Typography>
                </GridItem>
            )}
        </>
    );
};

export default withProductContext(connect(mapStateToProps)(StorePartsActions));
